import { EventEmitter, Injectable } from '@angular/core';

import { EarlyPayoutHelpers } from '../../my-bets-base/early-payout/my-bets-earlypayout-helpers';
import { CashoutSettingsBetInfo, CashoutSettingsType } from '../../my-bets-base/models/early-payout';

@Injectable()
export class CashoutSettingsService {
    // Will contain value without stake for FreeBets
    private betInfoArray: CashoutSettingsBetInfo[] = [];
    settingsChanged: EventEmitter<string> = new EventEmitter<string>();
    errorsCleared: EventEmitter<string> = new EventEmitter<string>();
    constructor(private epHelpers: EarlyPayoutHelpers) {}

    clearErrors(betid: string): void {
        this.errorsCleared.emit(betid);
    }

    addBetInfo(bet: CashoutSettingsBetInfo): void {
        const betExists = this.findBetIndex(bet.betslipId);
        if (betExists < 0) {
            this.betInfoArray.push(bet);
        }
    }

    getBetInfo(betslipId: string): CashoutSettingsBetInfo | null {
        const betExists = this.findBetIndex(betslipId);
        if (betExists < 0) {
            return null;
        }
        const retObject = Object.assign({}, this.betInfoArray[betExists]);

        return retObject;
    }

    updateAutoCashOutSettings(betslipId: string, value: number, type: CashoutSettingsType): boolean {
        const index = this.findBetIndex(betslipId);
        if (index < 0) {
            return false;
        }

        const valueWithoutStake = this.epHelpers.getValueWithoutFreeBetStake(
            this.betInfoArray[index].stake.value,
            value,
            this.betInfoArray[index].isFreeBet,
        );
        if (type === CashoutSettingsType.Auto) {
            this.betInfoArray[index].earlyPayout!.autoCashOutValue = value;
            this.betInfoArray[index].earlyPayout!.autoCashOutValueWithoutStake = valueWithoutStake;
        } else if (type === CashoutSettingsType.Notify) {
            this.betInfoArray[index].earlyPayout!.autoCashoutNotificationValue = value;
            this.betInfoArray[index].earlyPayout!.autoCashoutNotificationValueWithoutStake = valueWithoutStake;
        }

        this.settingsChanged.emit(this.betInfoArray[index].betslipId);

        return true;
    }

    private findBetIndex(betslipId: string): number {
        for (let i = 0; i < this.betInfoArray.length; i++) {
            if (this.betInfoArray[i].betslipId === betslipId) {
                return i;
            }
        }

        return -1;
    }

    removeBetInfo(betslipId: string): void {
        const index = this.findBetIndex(betslipId);

        if (index > -1) {
            this.betInfoArray.splice(index, 1);
        }
    }

    tryPushUpdateBetInfo(bet: CashoutSettingsBetInfo): void {
        const index = this.findBetIndex(bet.betslipId);
        if (index < 0) {
            this.betInfoArray.push(bet);
        } else {
            let hasChange = false;

            for (const prop in this.betInfoArray[index].earlyPayout!) {
                if (
                    bet.earlyPayout![prop as keyof typeof bet.earlyPayout] !==
                    this.betInfoArray[index].earlyPayout![prop as keyof typeof bet.earlyPayout]
                ) {
                    this.betInfoArray[index].earlyPayout![prop as keyof typeof bet.earlyPayout] =
                        bet.earlyPayout![prop as keyof typeof bet.earlyPayout];
                    hasChange = true;
                }
            }

            if (bet.possibleWinnings.value !== this.betInfoArray[index].possibleWinnings.value) {
                this.betInfoArray[index].possibleWinnings.value = bet.possibleWinnings.value;
                hasChange = true;
            }

            if (bet.grossPossibleWinnings.value !== this.betInfoArray[index].grossPossibleWinnings.value) {
                this.betInfoArray[index].grossPossibleWinnings.value = bet.grossPossibleWinnings.value;
                hasChange = true;
            }

            if (hasChange) {
                this.settingsChanged.emit(this.betInfoArray[index].betslipId);
            }
        }
    }
}
